(function () {
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  function getMainForm(formId) {
    if (!formId) return null;
    return document.getElementById(formId) || document.querySelector(`form[id="${formId}"]`);
  }

  function setup(bar) {
    // 二重初期化防止
    if (bar.__mfatc_inited) return;
    bar.__mfatc_inited = true;

    // Shopifyデフォルトの要素
    const formId = bar.getAttribute('data-main-form-id');
    const form = getMainForm(formId);
    if (!form) return;

    const mainFormVariant = form.querySelector('input[name="id"]');
    const mainFormSubmit = form.querySelector('button[name="add"], button[type="submit"][name="add"], button[type="submit"]');

    // 固定フォーム要素
    const variantSelect = bar.querySelector('[data-fixed-variant-select]');
    const submitBtn = bar.querySelector('[data-fixed-atc-submit]');

    const variantsEl = bar.querySelector('[data-mf-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    /* ===============================
       表示制御（IntersectionObserver）
    =============================== */
    let passedMainForm = false;
    let passedSpDescription = false;
    const mainObserver = new IntersectionObserver(([entry]) => {
      if (!mediaQuery.matches) return;

      if (entry.isIntersecting) {
        passedMainForm = false;
      } else {
        // 上に通過したか？
        passedMainForm = entry.boundingClientRect.top < 0;
      }

      updateFixedVisibility();
    }, { threshold: 0 });

    mainObserver.observe(form);

    const spDesc = document.getElementById('product-description-sp');

    if (spDesc) {
      const descObserver = new IntersectionObserver(([entry]) => {
        if (!mediaQuery.matches) return;

        if (entry.isIntersecting) {
          passedSpDescription = false;
        } else {
          // sp-description を上に通過したか？
          passedSpDescription = entry.boundingClientRect.top < 0;
        }

        updateFixedVisibility();
      }, { threshold: 0 });

      descObserver.observe(spDesc);
    }

    function updateFixedVisibility() {
      if (!mediaQuery.matches) {
        bar.classList.remove('is-active');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }

      if (passedMainForm && !passedSpDescription) {
        // 通常ATCは通過済み & sp-descriptionはまだ
        bar.classList.add('is-active');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-active');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    function isPassedTop(el, offset = 0) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      return rect.bottom <= offset;
    }

    function refreshPassedState() {
      if (!mediaQuery.matches) {
        passedMainForm = false;
        passedSpDescription = false;
        updateFixedVisibility();
        return;
      }

      const headerOffset = 0; // 固定ヘッダーがあるなら例: 60
      passedMainForm = isPassedTop(form, headerOffset);
      passedSpDescription = spDesc ? isPassedTop(spDesc, headerOffset) : false;

      updateFixedVisibility();
    }

    // observe直後に必ず一度は同期で判定
    refreshPassedState();
    requestAnimationFrame(refreshPassedState);
    setTimeout(refreshPassedState, 200);
    window.addEventListener('pageshow', refreshPassedState);

    // メインで設定されているバリエーションを反映
    if (mainFormVariant && variantSelect) {
      const currentId = mainFormVariant.value;
      const opt = variantSelect.querySelector(`option[value="${CSS.escape(currentId)}"]`);
      if (opt) variantSelect.value = currentId;
    }

    // バリエーション変更時にメインのバリエーションを変更
    function syncVariantToMain() {
      if (!variantSelect) return;

      const variantId = Number(variantSelect.value);
      const v = variants.find(x => x.id === variantId);
      if (!v) return;

      const scope = form.closest('section') || document;

      v.options.forEach((optValue) => {
        // form属性で紐づくradioを探す
        const radio = scope.querySelector(
          `input[type="radio"][form="${CSS.escape(formId)}"][value="${CSS.escape(optValue)}"]`
        );

        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        syncVariantToMain();
        const selectedOpt = variantSelect.options[variantSelect.selectedIndex];
        const soldOut = selectedOpt && selectedOpt.disabled;
        // 売り切れならボタンを非活性化
        if (submitBtn) submitBtn.toggleAttribute('disabled', !!soldOut);
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', () => {
        syncVariantToMain();

        // const qtyName = 'quantity';
        // let qtyInput = form.querySelector(`input[name="${qtyName}"]`);
        // if (!qtyInput) {
        //   qtyInput = document.createElement('input');
        //   qtyInput.type = 'hidden';
        //   qtyInput.name = qtyName;
        //   form.appendChild(qtyInput);
        // }
        // qtyInput.value = '1';

        if (mainFormSubmit) mainFormSubmit.click();
        else (form.requestSubmit ? form.requestSubmit() : form.submit());
      });
    }

    function updateVisibility() {
      if (!mediaQuery.matches) {
        bar.classList.remove('is-active');
        bar.setAttribute('aria-hidden', 'true');
      }
    }
    updateVisibility();
    mediaQuery.addEventListener?.('change', updateVisibility);

    // メイン側の更新も固定側へ反映
    if (mainFormVariant && variantSelect) {
      mainFormVariant.addEventListener('change', () => {
        const opt = variantSelect.querySelector(`option[value="${CSS.escape(mainFormVariant.value)}"]`);
        if (opt) variantSelect.value = mainFormVariant.value;
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mobile-fixed-atc]').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // テーマエディタ / セクション再描画対策
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
